<template>
  <div v-if="fields" class="jump-to-section content-center">
    <div class="content-constraint">
      <base-button :text="fields.buttonText" @click="scrollToTarget" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'JumpToSection',
  props: {
    fields: {
      type: Object,
      default: null
    }
  },
  methods: {
    scrollToTarget () {
      if (!this.fields.targetSection) return
      const targetId = this.fields.targetSection.sys.id
      const el = document.getElementById(targetId)
      if (el) {
        const offset = 80
        const top = el.getBoundingClientRect().top + window.scrollY - offset
        window.scrollTo({ top, behavior: 'smooth' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.jump-to-section {
  padding: 24px 0;
  text-align: center;
}
</style>
